import React from 'react';
import { Menubar } from 'primereact/menubar';
import { useNavigate } from 'react-router-dom';

const MenuTabletsAlmacen = ({ link }) => {

    const navigate = useNavigate();

    const nestedMenuitems = [
        {
            label: 'Entradas',
            icon: 'pi pi-arrow-circle-down',
            command: e => {
                navigate('/almacen/registro')
            }
        },
        {
            label: 'Salidas',
            icon: 'pi pi-arrow-circle-up',
            command: e => {
                navigate('/almacen/salida')
            }
        }
    ];

    return (
        <div className="col-12" style={{ marginBottom: "15px" }}>
            <Menubar model={nestedMenuitems} className="surface-card"></Menubar>
        </div>
    );
}

export default MenuTabletsAlmacen;